export default "__VITE_ASSET__Cz9BQ4Ve__"